import { Grid, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonFormField from "../../common/components/CommonFormField";
import CommonSelect from "../../common/components/CommonSelect";
import CommonCard from "../../common/components/CommonCard";
import { Academics, EnrollmentStatus, EnrollmentStatusObj, ExamAttempts, removeEmptyFields, Semesters, StudentGrade, SubjectArea, SubjectAreaObj, Subjects } from "../../common/const";
import CommonButton from "../../common/components/CommonButton";
import { Add } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { academicSuccess, setLoading } from "../../features/authSlice";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { createSubject, createAcademic, getAcademicInfo, updateAcademic } from "../../api/academicApi";
import moment from "moment";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { updateStudent } from "../../api/authApi";

const AcademicInfo = ({
    formData,
    setFormData
}) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { user, loading, academic } = useSelector((state) => state.auth);
    const [errors, setErrors] = useState({});

    const validateField = (name, value, subjectArea, firstAttempt, semester) => {
        switch (name) {
            case 'schoolname':
                if (!value) return 'School Name is required';
                return '';
            case 'academic':
                if (!value) return 'Academic is required';
                return '';
            case 'subject':
                if ((subjectArea === SubjectArea[0].value || subjectArea === SubjectArea[1].value) && !value) return 'Subject is required';
                return '';
            case 'grade':
                if ((subjectArea === SubjectArea[0].value || subjectArea === SubjectArea[1].value) && !value) return 'Semeste 1 Grade is required';
                return '';
            case 'SATSubject':
                if (subjectArea === SubjectArea[2].value && !value) return 'Subject is required';
                return '';
            case 'firstAttempt':
                if (subjectArea === SubjectArea[2].value && !value) return 'Is it a First Attempt? is required';
                return '';
            case 'examDate':
                if (subjectArea === SubjectArea[2].value && !value) return 'Exam Date is required';
                return '';
            case 'superScore':
                if (subjectArea === SubjectArea[2].value && !value) return 'Super Score is required';
                return '';
            case 'bestScore':
                if (subjectArea === SubjectArea[2].value && firstAttempt === ExamAttempts[1].value && !value) return 'Best Score is required';
                return '';
            case 'noOfAttempt':
                if (subjectArea === SubjectArea[2].value && firstAttempt === ExamAttempts[1].value && !value) {
                    return 'Number Of Attempts is required'
                } else if (subjectArea === SubjectArea[2].value && firstAttempt === ExamAttempts[1].value && value > 11) {
                    return 'Number of attempts cannot exceed 11. Please try again later.'
                }
                return '';
            default:
                return '';
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            academic: {
                ...prev.academic,
                [name]: value,
            },
        }));

        // Clear error for the field being changed
        if (errors[name]) {
            const error = validateField(name, value, formData.academic.subjectArea, formData.academic.firstAttempt, formData?.academic?.semester);
            if (!error) {
                setErrors(prev => ({ ...prev, [name]: undefined }));
            } else {
                setErrors(prev => ({ ...prev, [name]: error }));
            }
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const subjectArea = formData.academic.subjectArea;
        const firstAttempt = formData.academic.firstAttempt;

        if (subjectArea === SubjectArea[0].value || subjectArea === SubjectArea[1].value) {
            const fieldsToRemove = ['SATSubject', 'firstAttempt', 'examDate', 'bestScore', 'superScore', 'noOfAttempt'];
            fieldsToRemove.forEach(field => {
                if (formData.academic[field] !== undefined) {
                    delete formData.academic[field];
                }
            });

            // Only validate subject and grade for subjectArea 1
            ['schoolname', 'academic', 'startDate', 'endDate', 'subject', 'grade', 'semGrade'].forEach(key => {
                const error = validateField(key, formData.academic[key], subjectArea, firstAttempt, formData?.academic?.semester);
                if (error) newErrors[key] = error;
            });

        } else if (subjectArea === SubjectArea[2].value) {
            const fieldsToRemove = ['subject', 'grade'];
            fieldsToRemove.forEach(field => {
                if (formData.academic[field] !== undefined) {
                    delete formData.academic[field];
                }
            });

            ['schoolname', 'academic', 'startDate', 'endDate', 'SATSubject', 'firstAttempt', 'examDate', 'superScore', 'bestScore', 'noOfAttempt'].forEach(key => {
                const error = validateField(key, formData.academic[key], subjectArea, firstAttempt, formData?.academic?.semester);
                if (error) newErrors[key] = error;
            });
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        try {
            if (!validateForm()) return;
            dispatch(setLoading({
                loading: true
            }));
            let academicRes;
            const data = {
                "school_name": formData.academic.schoolname,
                "academic_status": formData.academic.academic,
                "start_date": formData.academic.startDate !== '' ? new Date(formData.academic.startDate).toISOString() : null,
                "end_date": formData.academic.endDate !== '' ? new Date(formData.academic.endDate).toISOString() : null,
                "student_grade": formData.academic.studentGrade,
                "student_id": user.student_id
            };
            if (academic === null) {
                const response = await createAcademic(removeEmptyFields(data));
                if (response.data.academic_id) {
                    academicRes = response.data;
                    dispatch(academicSuccess({
                        academic: response.data
                    }));
                    showNotification('Academic info added successfully', 'success');
                    dispatch(setLoading({
                        loading: false
                    }));
                }
            } else {
                const response = await updateAcademic(academic?.academic_id, removeEmptyFields(data));
                if (response.data.academic_id) {
                    academicRes = response.data;
                    dispatch(academicSuccess({
                        academic: response.data
                    }));
                    showNotification('Academic info updated successfully', 'success');
                    dispatch(setLoading({
                        loading: false
                    }));
                }
            }
            if (academic?.academic_id || academicRes?.academic_id) {
                localStorage.setItem('current_grade', formData.academic.studentGrade);
                if (formData.academic.academic === 'CURRENT') {
                    await updateStudent(user?.student_id, {
                        student_current_grade: formData.academic.studentGrade
                    });
                }
                dispatch(setLoading({
                    loading: true
                }));
                const subjecResponse = await createSubject({
                    subject_name: formData.academic.subject || Subjects.find((a) => a.value === formData.academic.SATSubject).label,
                    subject_area: SubjectAreaObj[formData.academic.subjectArea],
                    enrollment_status: formData.academic.enrollmentStatus ? EnrollmentStatusObj[formData.academic.enrollmentStatus] : null,
                    super_score: formData.academic.superScore || 0,
                    best_score: formData.academic.bestScore || 0,
                    grade: formData.academic.grade,
                    gpa: formData.academic.GPA,
                    start_date: formData.academic.subjectStartDate && formData.academic.subjectStartDate !== '' ? new Date(formData.academic.subjectStartDate).toISOString() : null,
                    end_date: formData.academic.subjectEndDate && formData.academic.subjectEndDate !== '' ? new Date(formData.academic.subjectEndDate).toISOString() : null,
                    is_first_attempt: ExamAttempts.find((a) => a.value === formData.academic.firstAttempt)?.label === 'Yes',
                    no_of_test_taken: formData.academic.noOfAttempt || 0,
                    test_date: formData.academic.examDate && formData.academic.examDate !== '' ? new Date(formData.academic.examDate).toISOString() : null,
                    is_active: true,
                    academic_id: academic?.academic_id || academicRes?.academic_id,
                    student_id: user?.student_id,
                    semester: formData?.academic?.semester,
                    semester2_grade: formData?.academic?.semGrade,
                    semester2_gpa: formData?.academic?.semGpa
                });
                if (subjecResponse) {
                    dispatch(setLoading({
                        loading: false
                    }));
                    showNotification('Academic subject added successfully', 'success');
                    setFormData((prev) => ({
                        ...prev,
                        academic: {
                            ...prev.academic,
                            schoolname: academic?.school_name || '',
                            academic: academic?.academic_status || '',
                            startDate: academic?.start_date || '',
                            endDate: academic?.end_date || '',
                            studentGrade: academic?.studentGrade || StudentGrade[0].value,
                            subjectArea: SubjectArea[0].value,
                            subject: '',
                            enrollmentStatus: EnrollmentStatus[0].value,
                            grade: '',
                            GPA: '',
                            subjectStartDate: '',
                            subjectEndDate: '',
                            SATSubject: Subjects[0].value,
                            firstAttempt: ExamAttempts[0].value,
                            examDate: '',
                            bestScore: '',
                            superScore: '',
                            noOfAttempt: '',
                            semester: Semesters?.["Semester 1"],
                            semGrade: '',
                            semGpa: ''
                        },
                    }));
                }
            }
            getAcademicData();
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;

            dispatch(setLoading({
                loading: false
            }));
            showNotification(errorMessage, 'error');
        }
    }

    const getAcademicData = async () => {
        const response = await getAcademicInfo(user.student_id);
        if (response?.data?.length > 0) {
            setFormData((prev) => ({
                ...prev,
                academic: {
                    ...prev.academic,
                    schoolname: response.data?.[0]?.school_name || '',
                    academic: response.data?.[0]?.academic_status || '',
                    startDate: response.data?.[0]?.start_date ? moment(response.data?.[0]?.start_date).format('YYYY-MM-DD') : '',
                    endDate: response.data?.[0]?.end_date ? moment(response.data?.[0]?.end_date)?.format('YYYY-MM-DD') : '',
                },
            }))
            dispatch(academicSuccess({
                academic: response.data?.[0]
            }));
        }
    }

    useEffect(() => {
        if (user?.student_id) {
            getAcademicData();
        }
    }, [user?.student_id]);

    const getMinDate = () => {
        const date = formData.academic.startDate ? new Date(formData.academic.startDate) : new Date();
        date.setDate(date.getDate() + 1); // Add 7 days
        return date.toISOString().split('T')[0];
    };

    const getMinEndDate = () => {
        const date = formData.academic.subjectStartDate ? new Date(formData.academic.subjectStartDate) : new Date();
        date.setDate(date.getDate() + 1); // Add 7 days
        return date.toISOString().split('T')[0];
    }

    return (
        <Grid container spacing={1.5} mt={0.5} mb={2}>
            {loading && (
                <LoadingSpinner />
            )}
            <Grid item xs={12} md={6}>
                <CommonFormField
                    label="School Name"
                    type="email"
                    name="schoolname"
                    value={formData.academic.schoolname}
                    onChange={handleInputChange}
                    placeholder="Enter School Name"
                    error={errors.schoolname}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <CommonSelect
                    label="Academic"
                    name="academic"
                    value={formData.academic.academic}
                    onChange={handleInputChange}
                    placeholder="Select academic"
                    options={Academics}
                    error={errors.academic}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <CommonFormField
                    label="Start Date"
                    type="date"
                    name="startDate"
                    value={formData.academic.startDate}
                    onChange={handleInputChange}
                    placeholder="Select Start Date"
                    error={errors.startDate}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <CommonFormField
                    label="End Date"
                    type="date"
                    name="endDate"
                    value={formData.academic.endDate}
                    onChange={handleInputChange}
                    placeholder="Select End Date"
                    error={errors.endDate}
                    maxDate={getMinDate()}
                />
            </Grid>
            <Grid item xs={12} md={12}>
                <CommonSelect
                    label="Student Grade"
                    name="studentGrade"
                    value={formData.academic.studentGrade}
                    onChange={handleInputChange}
                    placeholder="Select Grade"
                    options={StudentGrade}
                />
            </Grid>
            <Grid item xs={12}>
                <CommonCard
                    marginTop={0.5}
                    borderRadius={1}
                    border={`1px solid ${theme.palette.background.light}`}
                    content={
                        <Grid container spacing={1.5}>
                            <Grid item xs={12} md={12}>
                                <CommonSelect
                                    label="Subject Area"
                                    name="subjectArea"
                                    value={formData.academic.subjectArea}
                                    onChange={handleInputChange}
                                    placeholder="Select Subject Area"
                                    options={SubjectArea}
                                />
                            </Grid>
                            {(formData.academic.subjectArea === 1 || formData.academic.subjectArea === 2) && (
                                <>
                                    <Grid item xs={12} md={6}>
                                        <CommonFormField
                                            label="Subject"
                                            type="email"
                                            name="subject"
                                            value={formData.academic.subject}
                                            onChange={handleInputChange}
                                            error={errors.subject}
                                            placeholder="e.g., Mathematics"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <CommonSelect
                                            label="Enrollment Status"
                                            name="enrollmentStatus"
                                            value={formData.academic.enrollmentStatus}
                                            onChange={handleInputChange}
                                            placeholder="Select Status"
                                            options={EnrollmentStatus}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <CommonSelect
                                            label="Semester"
                                            name="semester"
                                            value={formData.academic.semester}
                                            onChange={handleInputChange}
                                            placeholder="Select Semester"
                                            options={[{
                                                label: 'Semester 1', value: 'SEMESTER_1'
                                            },
                                            {
                                                label: 'Semester 2', value: 'SEMESTER_2'
                                            }]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <CommonFormField
                                            label="Semester 1 Grade"
                                            type="email"
                                            name="grade"
                                            value={formData.academic.grade}
                                            onChange={handleInputChange}
                                            error={errors.grade}
                                            placeholder="e.g., A, A+, 95%"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <CommonFormField
                                            label="Semester 1 GPA"
                                            type="number"
                                            name="GPA"
                                            value={formData.academic.GPA}
                                            onChange={handleInputChange}
                                            placeholder="Enter GPA"
                                        />
                                    </Grid>
                                    {formData.academic.semester === Semesters?.["Semester 2"] && (
                                        <>
                                            <Grid item xs={12} md={6}>
                                                <CommonFormField
                                                    label="Semester 2 Grade"
                                                    type="email"
                                                    name="semGrade"
                                                    value={formData.academic.semGrade}
                                                    onChange={handleInputChange}
                                                    error={errors.semGrade}
                                                    placeholder="e.g., A, A+, 95%"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <CommonFormField
                                                    label="Semester 2 GPA"
                                                    type="number"
                                                    name="semGpa"
                                                    value={formData.academic.semGpa}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter GPA"
                                                />
                                            </Grid>
                                        </>
                                    )}
                                    <Grid item xs={12} md={6}>
                                        <CommonFormField
                                            label="Start Date"
                                            type="date"
                                            name="subjectStartDate"
                                            value={formData.academic.subjectStartDate}
                                            onChange={handleInputChange}
                                            placeholder="Select Start Date"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <CommonFormField
                                            label="End Date"
                                            type="date"
                                            name="subjectEndDate"
                                            value={formData.academic.subjectEndDate}
                                            onChange={handleInputChange}
                                            placeholder="Select End Date"
                                            minDate={getMinEndDate()}
                                        />
                                    </Grid>
                                </>
                            )}
                            {formData.academic.subjectArea === 3 && (
                                <>
                                    <Grid item xs={12} md={6}>
                                        <CommonSelect
                                            label="Select Subject"
                                            name="SATSubject"
                                            value={formData.academic.SATSubject}
                                            onChange={handleInputChange}
                                            placeholder="Select Subject"
                                            error={errors.SATSubject}
                                            options={Subjects}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <CommonSelect
                                            label="Is it a First Attempt?"
                                            name="firstAttempt"
                                            value={formData.academic.firstAttempt}
                                            onChange={handleInputChange}
                                            error={errors.firstAttempt}
                                            options={ExamAttempts}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <CommonFormField
                                            label="Exam Date"
                                            type="date"
                                            name="examDate"
                                            value={formData.academic.examDate}
                                            onChange={handleInputChange}
                                            error={errors.examDate}
                                            placeholder="Select exam date"
                                        />
                                    </Grid>
                                    {formData.academic.firstAttempt === 2 && (
                                        <>
                                            <Grid item xs={12} md={6}>
                                                <CommonFormField
                                                    label="Number Of Attempts"
                                                    type="number"
                                                    name="noOfAttempt"
                                                    value={formData.academic.noOfAttempt}
                                                    onChange={handleInputChange}
                                                    error={errors.noOfAttempt}
                                                    placeholder="Enter number of attempts"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <CommonFormField
                                                    label="Best Score"
                                                    type="number"
                                                    name="bestScore"
                                                    value={formData.academic.bestScore}
                                                    onChange={handleInputChange}
                                                    error={errors.bestScore}
                                                    placeholder="Enter best ccore"
                                                />
                                            </Grid>
                                        </>
                                    )}
                                    <Grid item xs={12} md={6}>
                                        <CommonFormField
                                            label="Super Score"
                                            type="number"
                                            name="superScore"
                                            value={formData.academic.superScore}
                                            onChange={handleInputChange}
                                            error={errors.superScore}
                                            placeholder="Enter super ccore"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 400, color: 'text.main' }}>
                                            Please provide all details, it will helpful for our AI algorithm, to calculate your better
                                            score
                                        </Typography>
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={12}>
                                <CommonButton
                                    label="Add Subject"
                                    background={theme.palette.secondary.main}
                                    color={theme.palette.background.main}
                                    fontWeight={600}
                                    handleClick={() => handleSubmit()}
                                    startIcon={<Add />}
                                    marginBottom={1}
                                />
                            </Grid>
                        </Grid>
                    }
                    paddingBottom={0}
                    padding="16px 16px 0px 16px"
                />
            </Grid>
        </Grid>
    )
}

export default AcademicInfo;